<script setup lang="ts">
import { onMounted } from 'vue';
import { useAuthStore } from '~/stores/auth';
import { isNilOrEmpty } from '~/utils';

interface Props
{
  compromisso: any
  fluxo?: any
}

const props = defineProps<Props>();

const emit = defineEmits(['close', 'loaded', 'success', 'error']);

const authStore = useAuthStore();

onMounted(() =>
{
  emit('loaded');
});
</script>

<template>
  <CompromissoJobCommandForm
    command="CompromissoCaqConcluirFluxoCommand"
    :show-upload-files="true"
    :show-devolver-button="true"
    :submit-button-disabled="!isNilOrEmpty(props.compromisso)
      && props.compromisso.responsavel.codigo !== authStore.codigoUsuario"
    :initial-model="{
      compromissoCodigos: [compromisso.codigo],
    }"
    @close="() => emit('close')"
  >
    <template #form="{ model }">
      <a-form-item
        label="Observação"
        name="observacao"
      >
        <a-textarea
          v-model:value="model.observacao"
          :rows="4"
        />
      </a-form-item>
    </template>
  </CompromissoJobCommandForm>
</template>
